function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { rem } from 'polished';
import React from 'react';
import Box from '../Box';
const ImproveIcon = _ref => {
  let {
    size,
    bg,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: rem(size),
    height: rem(size),
    fill: bg,
    verticalAlign: "middle"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6.238 2.148c.053-.197.333-.197.386 0l.837 3.11a.2.2 0 0 0 .142.142l3.11.838c.198.053.198.333 0 .386l-3.11.837a.2.2 0 0 0-.142.142l-.837 3.11c-.053.198-.333.198-.386 0L5.4 7.604a.2.2 0 0 0-.141-.142l-3.111-.837c-.197-.053-.197-.333 0-.386l3.11-.838A.2.2 0 0 0 5.4 5.26l.838-3.111ZM12.93 21.93a1 1 0 0 1 0-2h7a1 1 0 0 1 0 2h-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.78 3.224a1 1 0 0 0-1.414 0L13.95 5.638l.707.707-.707-.707-8.545 8.546a.999.999 0 0 0-.212.313 22.364 22.364 0 0 0-1.159 3.565 23.218 23.218 0 0 0-.32 1.6l-.005.026v.007l-.001.003.99.143-.99-.142a1 1 0 0 0 1.13 1.132l-.14-.99.14.99h.002l.003-.001.007-.001.026-.004.092-.014a23.291 23.291 0 0 0 1.507-.306 22.37 22.37 0 0 0 3.566-1.16.999.999 0 0 0 .313-.211l8.54-8.54.001-.001.004-.004s.001-.001-.706-.708l.706.708 2.416-2.416a1 1 0 0 0 0-1.414L17.78 3.224Zm.414 5.243-2.121-2.122 1-1 2.121 2.121-1 1Zm-3.536-.708 2.122 2.122-7.7 7.7a20.63 20.63 0 0 1-3.066.977l-.044.01.01-.043c.203-.848.518-1.955.978-3.065l7.7-7.7Z",
    clipRule: "evenodd"
  }));
};
ImproveIcon.defaultProps = {
  size: 16,
  bg: 'currentColor'
};
export default ImproveIcon;